import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="logo">
          <span className="logo-icon">💻</span>
          <span className="logo-text">CodeCruxDSA</span>
        </Link>
        <nav className="nav">
          <a href="#topics" className="nav-link">Topics</a>
          <a href="#questions" className="nav-link">Questions</a>
          <a href="#notes" className="nav-link">Unit Notes</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
